.wrap {
  padding: 80px 24px 64px;
  margin-top: 52px;
  text-align: center;
}
.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
}
.line {
  width: 46px;
  height: 1px;
  background: var(--rule);
}
.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: radial-gradient(circle at 32% 28%, #ffffff 0%, #f5ede2 38%, #e0d4c1 70%, #cdbda4 100%);
  box-shadow: 0 2px 5px rgba(120, 100, 70, 0.3);
}
.eyebrow {
  font-family: var(--font-script);
  font-size: 24px;
  color: var(--pink);
  margin-top: 32px;
}
.title {
  margin: 2px 0 0;
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 27px;
  letter-spacing: 3px;
  text-indent: 2px;
  color: var(--ink-2);
}
.lead {
  margin: 14px 0 0;
  font-size: 14.5px;
  line-height: 1.95;
  color: var(--muted);
}
.list {
  display: grid;
  gap: 12px;
  margin-top: 22px;
  text-align: left;
}
.panel {
  border-top: 1px solid var(--rule-3);
  border-bottom: 1px solid var(--rule-3);
  overflow: hidden;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px 6px;
  border: none;
  background: none;
  font: inherit;
  text-align: inherit;
  color: inherit;
  cursor: pointer;
}
.headerLeft {
  display: flex;
  align-items: center;
  gap: 10px;
}
.badge {
  border-radius: 999px;
  padding: 4px 12px;
  font-family: var(--font-detail);
  font-weight: 400;
  font-size: 11.5px;
  line-height: var(--font-detail-line-height);
  letter-spacing: 1px;
  background: var(--role-soft);
  color: var(--role-ink);
}
.headerTitle {
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 16.5px;
  letter-spacing: 1px;
  color: var(--ink-5);
}
.chevron {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-right: 1px solid var(--muted-2);
  border-bottom: 1px solid var(--muted-2);
  transition: transform 0.3s ease;
  transform: rotate(45deg);
  margin-top: -3px;
}
.chevronOpen {
  transform: rotate(-135deg);
}
.collapse {
  overflow: hidden;
  transition: max-height 0.45s ease;
}
.rows {
  padding: 2px 4px 14px;
  display: grid;
  gap: 2px;
}
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #e7ebef;
  padding: 9px 4px 11px;
}
.rowRole {
  font-family: var(--font-label);
  font-size: 13px;
  color: var(--muted-3);
}
.rowBank {
  font-family: var(--font-detail);
  font-size: 14.5px;
  font-weight: 400;
  line-height: var(--font-detail-line-height);
  letter-spacing: 0.3px;
  color: var(--ink);
  margin-top: 2px;
  white-space: nowrap;
}
.copyBtn {
  composes: tapTarget from '../styles/tapTarget.module.css';
  border: none;
  border-bottom: 1px solid var(--role-accent);
  background: none;
  padding: 0 1px 4px;
  font-family: var(--font-detail);
  font-weight: 400;
  font-size: 11.5px;
  line-height: var(--font-detail-line-height);
  color: var(--role-ink);
  cursor: pointer;
  flex-shrink: 0;
}
